import axiosapi from "./axiosAPI";

// Get All Manuals
export const getAllManuals = async (
    setManuals,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount
) => {
    const type = "";
    const page = ((event?.first)/(event?.rows))+1 || 1
    const limit = (event?.rows) || 10
	
    try {
		const res =await axiosapi.get(`/manuals?page=${page}&limit=${limit}&type=${type}`);
        setManuals(res.data.data ? res.data.data : {});
        setTotalCount(res.data.totalCount);
        setIsLoading(false);
        setFirst(event? event?.first:0);
        setRows(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Manuals");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Manuals");
		}
		
	}
	
};

export const getAllKits = async (
    setKits,
    setFetcherror,
    setIsLoadingKits,
    setFirstKits,
    setRowsKits,
    event,
    setTotalCountKits

) => {
    const type = "Kit";
    const page = ((event?.first) / (event?.rows)) + 1 || 1;
    const limit = (event?.rows) || 10;
	try{
		const res =await axiosapi.get(`/manuals?page=${page}&limit=${limit}&type=${type}`);
        setKits(res.data.data ? res.data.data : {});
        setTotalCountKits(res.data.totalCount);
        setIsLoadingKits(false);
        setFirstKits(event? event?.first:0);
        setRowsKits(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Manuals");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Manuals");
		}
		
	}
	
};

export const getAllReports = async (
    setReports,
    setFetcherror,
    setIsLoadingReports,
    setFirstReports,
    setRowsReports,
    event,
    setTotalCountReports
) => {
    const type = "Report";
    const page = ((event?.first) / (event?.rows)) + 1 || 1;
    const limit = (event?.rows) || 10;
	try{
		const res =await axiosapi.get(`/manuals?page=${page}&limit=${limit}&type=${type}`);
        setReports(res.data.data ? res.data.data : {});
        setTotalCountReports(res.data.totalCount);
        setIsLoadingReports(false);
        setFirstReports(event? event?.first:0);
        setRowsReports(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Manuals");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Manuals");
		}
		
	}
	
};

export const getAllUserManuals = async (
    setUserManuals,
    setFetcherror,
    setIsLoadingUserManuals,
    setFirstUserManuals,
    setRowsUserManuals,
    event,
    setTotalCountUserManuals
) => {
    const type = "User Manual";
    const page = ((event?.first) / (event?.rows)) + 1 || 1;
    const limit = (event?.rows) || 10;
	try{
		const res =await axiosapi.get(`/manuals?page=${page}&limit=${limit}&type=${type}`);
        setUserManuals(res.data.data ? res.data.data : {});
        setTotalCountUserManuals(res.data.totalCount);
        setIsLoadingUserManuals(false);
        setFirstUserManuals(event? event?.first:0);
        setRowsUserManuals(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Manuals");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Manuals");
		}
		
	}
	
};


// Get One Manual
export const getOneManual = async (
    pkid,
    setFetcherror,  
    setManual
    
)=>{
	try{
		const res =await axiosapi.get(`/manuals/${pkid}`);
        setManual(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Manual");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Manual");
		}
		
	}
	
};


// Create New Manual
export const createManual = async (
    manual,
    setManual,
    type,
    setType,
    file,
    setFile,
    setFetcherror,
    handleAllToasts,
    setManuals,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount
) => {



    if (!manual || !type || !file) {
        handleAllToasts(2, "No Manual Name, Type Provided or File has not been uploaded"); 
            return; 
        }

    const formData = new FormData();
    formData.append("name", manual);
    formData.append("type", type?.name);
    formData.append("uri", file);

    console.log("FORMDATA", formData);

    try {
        await axiosapi.post("/manuals/", formData, { headers: { 'Content-Type': 'multipart/form-data' }, });
        setManual("");
        setType("");
        setFile(null);
        handleAllToasts(1, "Manual Created Successfully");
        getAllManuals(setManuals,setFetcherror,setIsLoading,setFirst,setRows,event,setTotalCount);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Manual");
            handleAllToasts(2, "Could Not update The Manual");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Manual");
            handleAllToasts(2, "Could Not Create the manual The Manual");
            
        }
        
    }
    
}


// Edit Existing Manual

export const editManual = async (
    manualpkid,
    editedManual,
    setEditedManual,
    editedSelectedType,
    setEditedSelectedType,
    editedFile,
    setEditedFile,
    setFetcherror,
    handleAllToasts,
    setManuals,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount
              
        ) => {

            if (!(editedManual || editedSelectedType || editedFile)) {
                handleAllToasts(2, "Nothing altered or Nothing Entered"); 
                    return;  
                }

    const formData = new FormData();
                formData.append("id",manualpkid)
                formData.append("name", editedManual);
                formData.append("type", editedSelectedType?.name);
                formData.append("uri", editedFile);

            try{
                await axiosapi.patch("/manuals/",formData, { headers: { 'Content-Type': 'multipart/form-data' }, } );
                setEditedManual("");
                setEditedSelectedType("");
                setEditedFile(null);
                handleAllToasts(1, "Manual Updated Successfully");
                getAllManuals(setManuals,setFetcherror,setIsLoading,setFirst,setRows,event,setTotalCount);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Manual");
                    handleAllToasts(2, "Could Not Update Manual");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Manual");
                    handleAllToasts(2, "Could Not Update Manual");
                    
                }
                
            }
            
};



// Delete Existing Manual.

export const deleteManual = async (
    manualpkid,
    setManuals,
    setFetcherror,
    handleAllToasts,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount

)=>{
    try {
        const res = await axiosapi.delete(`/manuals/${manualpkid}`);
        let finalData = res.data.message;
        getAllManuals(setManuals,setFetcherror,setIsLoading,setFirst,setRows,event,setTotalCount);
        handleAllToasts(1, "Manual Deleted Successfully");
        console.log("Deleted:", finalData);
        
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Manual");
            handleAllToasts(2,"Error: Could Not Delete Manual");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Manual");
            handleAllToasts(2,"Error: Could Not Delete Manual");
		}
		
	}
	
};